// gclid.js
function initGclid() {
    checkAndRemoveOldGclid();
        
    var gclid = getQueryStringParameter('gclid');
    if (gclid) {
        localStorage.setItem('last_gclid', gclid);
        localStorage.setItem('last_gclid_date', new Date().toISOString());
    }
    
    function getQueryStringParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    
    function checkAndRemoveOldGclid() {
        var lastGclidDate = localStorage.getItem('last_gclid_date');
        if (lastGclidDate) {
            var currentDate = new Date();
            var lastDate = new Date(lastGclidDate);
            var timeDiff = Math.abs(currentDate.getTime() - lastDate.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays > 30) {
                localStorage.removeItem('last_gclid');
                localStorage.removeItem('last_gclid_date');
            }
        }
    }
    
    window.getLastGclid = function() {
        return localStorage.getItem('last_gclid');
    }
}

// utm.js
function initUtm() {
    checkAndRemoveOldParams();
        
    var utmParams = getUTMParameters();
    if (Object.keys(utmParams).length > 0) {
        localStorage.setItem('last_utm_params', JSON.stringify(utmParams));
        localStorage.setItem('last_utm_params_date', new Date().toISOString());
    }
    
    function getQueryStringParameters() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var queryParams = queryString.split('&');
        queryParams.forEach(function(param) {
            var pair = param.split('=');
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
            params[key] = value;
        });
        return params;
    }
    
    function getUTMParameters() {
        var queryParams = getQueryStringParameters();
        var utmParams = {};
        for (var key in queryParams) {
            if (key.startsWith('utm_')) {
                utmParams[key] = queryParams[key];
            }
        }
        return utmParams;
    }
    
    function checkAndRemoveOldParams() {
        var lastParamsDate = localStorage.getItem('last_utm_params_date');
        if (lastParamsDate) {
            var currentDate = new Date();
            var lastDate = new Date(lastParamsDate);
            var timeDiff = Math.abs(currentDate.getTime() - lastDate.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays > 30) {
                localStorage.removeItem('last_utm_params');
                localStorage.removeItem('last_utm_params_date');
            }
        }
    }
    
    window.getLastUTMParams = function() {
        var utmParams = localStorage.getItem('last_utm_params');
        return utmParams ? JSON.parse(utmParams) : {};
    }
}

//referral_code
function initReferral() {
    checkAndRemoveOldReferral();
        
    var referralCode = getQueryStringParameter('referrer');
    if (referralCode) {
        localStorage.setItem('referral_code', referralCode);
        localStorage.setItem('referral_code_date', new Date().toISOString());
        openReferralModal(referralCode); // Open the modal with the referral code
    }
    
    function getQueryStringParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    
    function checkAndRemoveOldReferral() {
        var lastReferralDate = localStorage.getItem('referral_code_date');
        if (lastReferralDate) {
            var currentDate = new Date();
            var lastDate = new Date(lastReferralDate);
            var timeDiff = Math.abs(currentDate.getTime() - lastDate.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays > 7) {
                localStorage.removeItem('referral_code');
                localStorage.removeItem('referral_code_date');
            }
        }
    }
    
    window.getLastReferralCode = function() {
        return localStorage.getItem('referral_code');
    }
    
    function openReferralModal(referralCode) {
        // Get the modal element
        var modal = document.getElementById("referralModal");
        // Get the element to display the referral code
        var referralCodeElement = document.getElementById("referralCode");
        // Set the referral code in the modal
        referralCodeElement.textContent = referralCode;
        // Show the modal
        modal.style.display = "block";
    }
  
}

// Main script
window.addEventListener('load', function() {
    initGclid();
    initUtm();
    initReferral();
});

document.addEventListener('DOMContentLoaded', (event) => {
    // Get the modal
    var modal = document.getElementById("referralModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
        modal.style.display = "none";
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }
});
